import { defineComponent as o, openBlock as r, createBlock as a, normalizeProps as n, guardReactiveProps as p, withCtx as l, renderSlot as c, createElementVNode as s } from "vue";
import d from "../CdrIcon.vue.mjs";
const m = /* @__PURE__ */ s("path", {
  role: "presentation",
  d: "M8 12c0 .273.11.521.288.702l5.005 5.005a1 1 0 001.414-1.414L10.415 12l4.295-4.295a1 1 0 00-1.417-1.412l-4.98 4.98A.997.997 0 008 12z"
}, null, -1), _ = /* @__PURE__ */ o({
  name: "CaretLeft",
  __name: "caret-left",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (t, f) => (r(), a(d, n(p(e.props)), {
      default: l(() => [c(t.$slots, "default"), m]),
      _: 3
    }, 16));
  }
});
export {
  _ as default
};
